import { createAsyncThunk } from "@reduxjs/toolkit";
import { setAlertsData } from "../../alertsSlice";
import { alertsDrawerEditModeSelector } from "../../selectors/alertsDrawerEditModeSelector";
import { RootState } from "@/store/store";
import { commitmentsOrganizationsSelector } from "@/store/commitments/selectors/organisations/commitmentsOrganizationsSelector";
import { CommitmentCloudProvider } from "@/services/cloudchipr.api";

export const initiateUtilizationAlertThunk = createAsyncThunk(
  "alerts/initiateUtilizationAlert",
  (enableAzure: boolean, { dispatch, getState }) => {
    const state = getState() as RootState;
    const organizations = commitmentsOrganizationsSelector(state, enableAzure);
    const firstOrgWithSavingsPlan = organizations?.find(
      (org) => org.has_savings_plan,
    );

    const editMode = alertsDrawerEditModeSelector(state);

    dispatch(
      setAlertsData({
        threshold: {
          threshold_items: [
            {
              unit: "day",
              amount: "1",
            },
          ],
        },
      }),
    );

    if (!editMode && firstOrgWithSavingsPlan) {
      dispatch(
        setAlertsData({
          providerOrganisationId:
            firstOrgWithSavingsPlan.organization_id ?? undefined,
          provider: (firstOrgWithSavingsPlan.cloud_provider ??
            "aws") as CommitmentCloudProvider,
        }),
      );
    }
  },
);
